import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=3cbb23a2&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/download.scss?vue&type=style&index=0&id=3cbb23a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb23a2",
  null
  
)

export default component.exports